import { render, staticRenderFns } from "./LevyCollectionProviderListing.vue?vue&type=template&id=a123b686&scoped=true&"
import script from "./LevyCollectionProviderListing.vue?vue&type=script&lang=js&"
export * from "./LevyCollectionProviderListing.vue?vue&type=script&lang=js&"
import style0 from "./LevyCollectionProviderListing.vue?vue&type=style&index=0&id=a123b686&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a123b686",
  null
  
)

export default component.exports